import {Injectable} from "@angular/core";
import {AuthApiService} from "../auth/auth-api.service";
import {firstValueFrom} from "rxjs";
import {HttpClient} from "@angular/common/http";

export class ClickUpFieldOption {
    constructor(public id: string, public name: string) {
    }
}

@Injectable()
export class ClickUpService {
    constructor(private auth: AuthApiService, private http: HttpClient) {
    }

    async getCustomFieldOptions(field: string): Promise<ClickUpFieldOption[]> {
        return firstValueFrom(this.http.get<ClickUpFieldOption[]>("/fonzie/clickup-custom-field-options/" + field, {headers: this.auth.getHttpHeaderOptions()}));
    }
}
